
import { toHead } from 'vue-datocms'
import { url } from '~/utils/seo'
import { articlePageQuery } from '~/gql/articlePage.graphql'
import DetailPage from '~/components/public/detail-page.vue'

export default {
  components: {
    DetailPage,
  },
  layout: 'default',
  meta: {
    isPublic: true,
  },
  async asyncData({ $graphql, params, i18n, error }) {
    const variables = {
      locale: i18n.locale,
      slug: params.slug,
    }

    try {
      const response = await $graphql.default.request(
        articlePageQuery,
        variables,
      )

      const { article } = response

      if (!article) {
        return error({ statusCode: 404, message: "Page doesn't exist" })
      }

      return { pageData: article }
    } catch (e) {
      console.error(e)

      return error({
        statusCode: 500,
        message: 'There was an error loading the page',
      })
    }
  },
  head() {
    if (!this.pageData.seo) {
      return
    }

    const alternates = this.pageData.slugLocales.filter((item) => {
      return item.slug !== this.pageData.slug
    })

    return {
      ...toHead(this.pageData.seo),
      link: alternates.map((item) => {
        const localePath = this.$nuxt.context.app.localePath(
          'articles',
          item.locale,
        )

        const href = `${url}/${localePath}/${item.slug}`
        return {
          rel: 'alternate',
          hreflang: item.locale,
          href,
        }
      }),
    }
  },
  computed: {
    metaInformation() {
      return {
        tags: this.pageData.tags,
        firstPublishedAt: this.pageData.firstPublishedAt,
        readingTimeInMinutes: this.pageData.readingTimeInMinutes,
      }
    },
  },
}
